import React from "react";
import { ReviewStarIcon } from "../Icons";
import { StyledRating } from "../../styles/styledComponents";
import { useMediaQuery } from "@mui/material";

type Props = {
    value: number | null;
    handleRatingChange?: (value: any) => void;
    iconWidth?: number; // set this to change the width of the Review Star icon
    iconHeight?: number; // set this to change the height of the Review Star icon
    readonly?: boolean; // pls set this to true if you want the rating to be readonly
}

// it's a controlled component that takes value and setValue as props

const ReviewRating = (props: Props) => {
  const isSmallScreen = useMediaQuery("(max-width: 600px)");

  const { value, handleRatingChange, iconWidth=isSmallScreen ? 24: 56, iconHeight=isSmallScreen ? 24: 56,
    readonly=false } = props;

  return (
    <div>
      <StyledRating name="appointment-rating" value={value} precision={1}
        readOnly={readonly}
        icon={<ReviewStarIcon width={iconWidth} height={iconHeight} />}
        emptyIcon={<ReviewStarIcon width={iconWidth} height={iconHeight} />}
        onChange={(event, newValue) => {
          if (newValue === null) {
            handleRatingChange && handleRatingChange(0);
          } else {
            handleRatingChange && handleRatingChange(newValue);
          }
        }}/>
    </div>
  );
};

export default ReviewRating;
